import {
  MOTE_DOMAIN_URL_REGEX,
  MOTE_LINK_DOMAIN,
  SHORT_LINK_DOMAIN,
  TOTE_LINK_DOMAIN
} from '../constants'

const MATCHER = new RegExp(
  `(${MOTE_LINK_DOMAIN}|${SHORT_LINK_DOMAIN}|${TOTE_LINK_DOMAIN}|m0t.us/)([0-9a-z]{5,9})`
)

function getDetails(url: string, id: string): MoteOrToteDetails | null {
  if (MOTE_DOMAIN_URL_REGEX.test(url)) {
    const domain =
      url === MOTE_LINK_DOMAIN ? MOTE_LINK_DOMAIN : SHORT_LINK_DOMAIN

    return { type: 'mote', url: `${domain}${id}`, id }
  } else if (url === TOTE_LINK_DOMAIN) {
    return { type: 'tote', url: `${TOTE_LINK_DOMAIN}${id}`, id }
  }

  return null
}

export interface MoteOrToteDetails {
  type: 'mote' | 'tote'
  url: string
  id: string
}

export function extractMoteOrToteDetailsFromText(
  text: string
): MoteOrToteDetails | null {
  const match = text.match(MATCHER)

  if (!match) return null

  const url = match[1]
  const id = match[2]

  return getDetails(url, id)
}
